<template>
  <div class="space-y-6 pb-4">
    <BaseButton
      v-if="$membershipHasPermissionTo('create email messages')"
      primary
      small
      @click="handleWriteEmail"
    >
      Write Email
    </BaseButton>

    <EmailMessageList ref="emailMessageList" :contact="contact" />
  </div>
</template>

<script>
import EmailMessageList from './EmailMessageList.vue';

export default {
  components: {
    EmailMessageList,
  },
  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleWriteEmail() {
      this.$modal.show({
        component: () =>
          import(
            '@/components/ContactEmailMessage/WriteEmailMessageDialog/WriteEmailMessageDialog.vue'
          ),
        props: {
          contact: this.contact,
        },
        on: {
          saved: () => {
            this.$refs.emailMessageList.fetchData();
          },
          sent: () => {
            this.$refs.emailMessageList.fetchData();
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
